import { msgTypes } from "constants/msgTypes";
import { Validation } from "constants/Validation";
import * as Yup from "yup";

const MembershipFormSchema = [

    Yup.object().shape({
    companyName: Yup.string()
    .required(Validation.required.message.replaceAll("^", "Company Name"))
    .test('valid-name', 'Company Name must be at least 3 characters', (value) => {
        if (!value) return false;
        const trimmedValue = value.trim();
        return trimmedValue.length >= 3 && Validation.plaintext.regex.test(trimmedValue);
    })
    .test('not-only-numbers', 'Company Name cannot contain only numbers', (value) => {
        if (!value) return false;
        const trimmedValue = value.trim();
        return /[a-zA-Z]/.test(trimmedValue); // Must contain at least one letter
    }),
        companyEmail: Yup.string().required(Validation.required.message.replaceAll("^", "Company Email"))
            .matches(Validation.email.regex, Validation.email.message),
        primaryPhoneNumber: Yup.string().required(Validation.required.message.replaceAll("^", "Phone Number"))
            .matches(Validation.mobile.regex, Validation.mobile.message)
            .min(10, Validation.minlength.message.replaceAll("^", 10))
            .max(15, Validation.maxlength.message.replaceAll("^", 15)),
        secondaryPhoneNumber: Yup.string()
            .matches(Validation.mobile.regex, Validation.mobile.message)
            .min(10, Validation.minlength.message.replaceAll("^", 10))
            .max(15, Validation.maxlength.message.replaceAll("^", 15)),
        websiteUrl: Yup.string()
    .matches(Validation.website.regex, Validation.website.message)
    .test('no-spaces', 'Website URL cannot contain spaces', (value) => {
        return !value || !value.includes(' ');
    }),
        accountingEmail: Yup.string().matches(Validation.email.regex, Validation.email.message),
        companyLogo: Yup.string(),
        companyLogoFile: Yup.mixed().nullable()
        .test(
            "FILE_FORMAT",
            msgTypes.IMAGE_UNSUPPORTED_FORMAT,
            (value) => !value || (value && [msgTypes.IMAGE_FORMAT.JPEG,
                msgTypes.IMAGE_FORMAT.JPG, msgTypes.IMAGE_FORMAT.PNG, msgTypes.IMAGE_FORMAT.WEBP, msgTypes.IMAGE_FORMAT.WORD
            ].includes(value?.type))
        )
        .test(
            "FILE_SIZE",
            msgTypes.FILE_SIZE_MESSAGE_100,
            (value) =>!value || (value && value.size <=msgTypes.FILE_SIZE_100)
        )
        //.required(Validation.required.message.replaceAll("^", "Company Logo"))
    }),
    Yup.object().shape({
        addressLine1: Yup.string().required(Validation.required.message.replaceAll("^", "Address 1"))
            .matches(Validation.plaintext.regex, Validation.plaintext.message),
        addressLine2: Yup.string().required(Validation.required.message.replaceAll("^", "Address 2"))
            .matches(Validation.plaintext.regex, Validation.plaintext.message),
        cityId: Yup.number(),
        //.required(Validation.required.message.replaceAll("^", "City")),
        stateId: Yup.number(),
        //.required(Validation.required.message.replaceAll("^", "State")),
        countryId: Yup.number().required(Validation.required.message.replaceAll("^", "Country")),
        zipCode: Yup.string()
  .required(Validation.required.message.replaceAll("^", "Zip Code"))
  .matches(Validation.zipCode.regex, Validation.zipCode.message)
 .test(
  "not-all-zeros",
  "Zip Code cannot be all zeros",
  (value) => !/^0+$/.test(value || "")
),
    }),
    Yup.object().shape({
        companyDetails: Yup.string()
    .test('required-not-empty', 'Company Description is required and cannot be empty', 
        value => value && value.trim().length > 0
    )
    .matches(Validation.plaintext.regex, Validation.plaintext.message),
    }),
    Yup.object().shape({
        instagramUrl: Yup.string().matches(Validation.website.regex, Validation.website.message),
        linkedinUrl: Yup.string().matches(Validation.website.regex, Validation.website.message),
        twitterUrl: Yup.string().matches(Validation.website.regex, Validation.website.message),
        facebookUrl: Yup.string().matches(Validation.website.regex, Validation.website.message),
        youtubeUrl: Yup.string().matches(Validation.website.regex, Validation.website.message)
    }),
    Yup.object().shape({
        membershipType: Yup.string().required(Validation.required.message.replaceAll("^", "Membership Type")),
    }),
    Yup.object().shape({
        contactPerson: Yup.array()
    }),
];

export default MembershipFormSchema;